"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
// styles
require("./portal.scss");
// creates a div that will be appended to the HTML body
const createElement = (id, dataTestId) => {
    document.createElement("div");
    const element = document.createElement("div");
    element.id = id;
    document.body.appendChild(element);
    element.dataset.testid = dataTestId;
    return element;
};
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-portal",
};
/**
 *  This component create a React Portal
 * Each time the component mount, check if the div used to show the modal already exists
 * if it is so, this div will be reused otherwise another div will be created
 * Each time the component unmount, remove the modal div from the DOM
 */
const Portal = ({ id, children, "data-testid": dataTestId }) => {
    const portalContainer = document.getElementById(id) || createElement(id, dataTestId || "");
    /**
     * the following effect returns a clean-up function to be performed
     * on component unmount: removes the given portalContainer if empty.
     */
    (0, react_1.useEffect)(() => () => {
        if (portalContainer && portalContainer.innerHTML === "") {
            portalContainer.remove();
        }
    }, []);
    return (0, react_dom_1.createPortal)(children, portalContainer);
};
Portal.defaultProps = defaultProps;
exports.default = react_1.default.memo(Portal);
